<template>
  <div class="register">
    <!--  表单部分  -->
    <div class="form">
      <div class="forms">
        <el-form ref="UserRegisterLegalEntityDTO1" :model="UserRegisterLegalEntityDTO.user"  label-position="right" label-width="168px" :rules="rules" style="width:100%">
          <div class="form-item">
              <div class="form-title">账户信息</div>
              <div class="form-input">
                  <el-row>
                      <el-col :span="24">
                          <el-form-item class="form_inputs"   label="用户名:"  prop="account">
                              <el-input placeholder="6~20位字母或‘字母+数字’（不能以数字开头）"  v-model="UserRegisterLegalEntityDTO.user.account"></el-input>
                          </el-form-item>
                      </el-col>
                  </el-row>
                  <el-row>
                      <el-col :span="24">
                          <el-form-item  class="form_inputs" label="设置密码:"  prop="pdk">
                              <el-input placeholder="必须是12-30位包含大小写、数字、特殊字符组合" type="password" v-model="UserRegisterLegalEntityDTO.user.pdk"></el-input>
                          </el-form-item>
                      </el-col>
                  </el-row>
                  <el-row>
                      <el-col :span="24">
                          <el-form-item class="form_inputs" label="确认密码:" prop="passwordAgain">
                              <el-input placeholder="请保持两次密码输入一致" type="password" v-model="UserRegisterLegalEntityDTO.user.passwordAgain"></el-input>
                          </el-form-item>
                      </el-col>
                  </el-row>
              </div>
          </div>
        </el-form>
        <el-form  ref="UserRegisterLegalEntityDTO2" :model="UserRegisterLegalEntityDTO.naturalPerson"  label-position="right" label-width="168px" style="width:100%" :rules="rules">
          <div class="form-item">
            <div class="form-title">个人信息</div>
              <div class="form-input">
                <el-row >
                  <el-col :span="24">
                      <el-form-item class="form_inputs" label="姓名:" prop="name">
                          <el-input v-model="UserRegisterLegalEntityDTO.naturalPerson.name"></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="24">
                      <el-form-item class="form_inputs" label="电话:" prop="telephone">
                          <el-input v-model="UserRegisterLegalEntityDTO.naturalPerson.telephone"></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="24">
                      <el-form-item class="form_inputs" label="手机:"  prop="mobilePhone">
                              <el-input v-model="UserRegisterLegalEntityDTO.naturalPerson.mobilePhone"></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="24">
                      <el-form-item class="form_inputs" label="邮箱:"  prop="email">
                          <el-input v-model="UserRegisterLegalEntityDTO.naturalPerson.email"></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="24">
                      <el-form-item class="form_inputs" label="所属企业:"  prop="entName">
                        <el-input v-model="UserRegisterLegalEntityDTO.naturalPerson.entName"></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="24">
                      <el-form-item class="form_inputs" label="企业统一社会信用代码:"  prop="uscCode">
                          <el-input v-model="UserRegisterLegalEntityDTO.naturalPerson.uscCode"></el-input>
                      </el-form-item>
                  </el-col>
                </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <el-form  ref="UserRegisterLegalEntityDTO3" :model="UserRegisterLegalEntityDTO.verifyCode" :rules="rules"  label-position="right" label-width="168px">
          <div class="forms">
                <div class="form-item">
                  <div class="form-input">
                      <el-form-item class="form-item" label="验证码:" prop="value">
                          <el-input v-model="UserRegisterLegalEntityDTO.verifyCode.value" style="width: 8rem; float: left"></el-input>
                          <img style="height: 40px; margin-left: 1rem" :src="imgVerifyCode" @click="getVerifyCode">
                      </el-form-item>
                  </div>
              </div>
          </div>
          <el-form-item class="form-button" style="text-align: center;margin-top: 50px;">
            <el-button @click="cancel()">取消</el-button>
            <el-button type="primary" @click="submit()">注册</el-button>
          </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Message } from 'element-ui'

export default {
  name: 'Register',
  data () {
    return {
      rules: {
        account: [
          { required: true, message: '请输入用户名', trigger: ['blur', 'change'] },
          { pattern: /^[a-zA-Z]\w{5,19}$/, message: '6~20位字母或‘字母+数字’（不能以数字开头）' }
        ],
        pdk: [
          { required: true, message: '请输入密码', trigger: ['blur', 'change'] },
          { validator: this.validatePass, trigger: ['blur', 'change'] }
        ],
        passwordAgain: [
          { required: true, message: '请再次输入密码', trigger: ['blur', 'change'] },
          { validator: this.validatePassAgain, trigger: ['blur', 'change'] }
        ],
        value: [
          { required: true, message: '请输入验证码', trigger: ['blur', 'change'] }
        ],
        name: [{ required: true, message: '请输入联系人', trigger: ['blur', 'change'] }],
        telephone: [
          { required: true, message: '请输入电话', trigger: ['blur', 'change'] },
          { pattern: /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/, message: '固话格式有误' }
        ],
        mobilePhone: [
          { required: true, message: '请输入手机', trigger: ['blur', 'change'] },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号格式有误' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: ['blur', 'change'] },
          { pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: '邮箱格式有误' }
        ],
        entName: [
          { required: true, message: '请输入所属企业名称', trigger: ['blur', 'change'] }
        ],
        uscCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: ['blur', 'change'] },
          { pattern: /^[0-9A-Z]{18}$/, message: '统一社会信用代码格式错误' }
        ]
      },
      passwordAgain: '',
      clickclassif: 1,
      imgVerifyCode: `${process.env.VUE_APP_LOADING_IMG}`,
      UserRegisterLegalEntityDTO: {
        naturalPerson: {
          name: '',
          email: '',
          mobilePhone: '',
          telephone: '',
          entName: '',
          uscCode: ''
        },
        user: {
          account: '',
          pdk: ''
        },
        verifyCode: {
          key: '',
          value: ''
        }
      }
    }
  },
  mounted () {
    this.getVerifyCode()
  },
  methods: {
    cancel () {
      this.$router.push({ path: '/login' })
    },
    getVerifyCode () {
      const _this = this
      _this.UserRegisterLegalEntityDTO.verifyCode.value = ''
      axios.get('/opbj/ucenter2/ucenter/user/front/getVerifyCode').then(function (response) {
        const res = response.data
        if (res.status !== 200) {
          Message({
            message: res.message,
            type: 'warning'
          })
          return
        }
        _this.imgVerifyCode = 'data:img/png;base64,' + res.data.value
        _this.UserRegisterLegalEntityDTO.verifyCode.key = res.data.key
      })
    },
    validatePass (rule, value, callback) {
      if (!/^(?![0-9]+$)(?![^0-9]+$)(?![a-zA-Z]+$)(?![^a-zA-Z]+$)(?![a-zA-Z0-9]+$)[a-zA-Z0-9\S]{12,30}$/.test(value)) {
        callback(new Error('必须是12-30位包含大小写、数字、特殊字符组合'))
        return
      }
      if (!this.UserRegisterLegalEntityDTO.user.passwordAgain) {
        callback()
        return
      }
      this.$refs.UserRegisterLegalEntityDTO1.validateField('passwordAgain')
      callback()
    },
    validatePassAgain (rule, value, callback) {
      if (!value) {
        callback(new Error('请再次输入密码'))
        return
      }
      if (value !== this.UserRegisterLegalEntityDTO.user.pdk) {
        callback(new Error('两次密码不一致'))
        return
      }
      callback()
    },
    submit () {
      const _this = this
      const formName = ['UserRegisterLegalEntityDTO1', 'UserRegisterLegalEntityDTO2', 'UserRegisterLegalEntityDTO3']
      const validates = (item) => {
        return new Promise((resolve, reject) => {
          if (!this.$refs[item]) {
            resolve()
            return false
          }
          this.$refs[item].validate((valid) => {
            if (valid) {
              resolve()
            } else {
              reject(new Error('验证不对'))
            }
          })
        })
      }
      Promise.all(formName.map(item => validates(item))).then(() => {
        axios.post(`${process.env.VUE_APP_SERVER_URL}/ucenter/user/front/naturalPersonRegister`, this.UserRegisterLegalEntityDTO)
          .then(function (response) {
            const res = response.data
            if (res.status !== 200) {
              Message({
                message: res.message,
                type: 'warning'
              })
              _this.getVerifyCode()
              return
            }
            Message({
              message: res.message,
              type: 'success',
              onClose: _this.cancel
            })
          })
      }).catch(() => {
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/base.scss";

.register {
  width: 1200px;
  margin: 0 auto;
  .visibility {
    margin-bottom: 30px;
    visibility: hidden;
  }
  .visibilitys{
    margin-bottom: 48px;
  }
  .form {
        width: 1000px;
        margin: 20px auto;

        .forms{
                display: flex;
                justify-content: space-between;
            .form-item {
                width: 100%;
                .form-input {
                    margin-left: 65px;
                    .form_inputs{
                        margin-bottom: 20px;
                    }
                }

            .form-title {
                @include font_size($font_large);
                font-weight: bold;
                margin-bottom: 10px;
                margin-left: 50px;
            }

            .double-line {
                ::v-deep.el-form-item__label {
                line-height: 20px;
                }
            }
            }
        }
    }
}
</style>
